export const OMOP_ETL_RUN_REQUEST = 'OMOP_ETL_RUN_REQUEST';
export const OMOP_ETL_RUN_SUCCESS = 'OMOP_ETL_RUN_SUCCESS';
export const OMOP_ETL_RUN_FAIL = 'OMOP_ETL_RUN_FAIL';
export const OMOP_ETL_RUN_RESET = 'OMOP_ETL_RUN_RESET';
